import type { RegionCode } from '../graphql/api'

export const noPrefixRegion = 'UK' satisfies RegionCode

export const defaultRegion = 'UK' satisfies RegionCode

export type RoutingRegion =
    | Lowercase<Exclude<RegionCode, typeof noPrefixRegion>>
    | ''

export function getRoutingRegion(regionCode: RegionCode): RoutingRegion {
    if (noPrefixRegion === regionCode) {
        return ''
    }

    return regionCode.toLowerCase() as RoutingRegion
}

const ActiveRegion: Record<RegionCode, boolean> = {
    AU: false,
    CA: false,
    EU: false,
    IE: false,
    INT: false,
    NZ: false,
    UK: true,
    US: true,
    ZA: false,
} as const

export const getIsActiveRegion = (regionCode: RegionCode): boolean =>
    Boolean(ActiveRegion[regionCode])
